import * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Thu Dec 04 2025 14:06:53 GMT+0000 (Coordinated Universal Time)
*/

const defaultOptions = {} as const;
export type SpeakersQueryVariables = Types.Exact<{
  mediaHashedId: Types.Scalars['HashedId']['input'];
}>;


export type SpeakersQuery = { __typename?: 'Query', anonymousMedia?: { __typename?: 'AnonymousMedia', id: string, transcriptSpeakers: Array<{ __typename?: 'TranscriptSpeaker', id: string, role: Types.SpeakerRole, rowOrder: number, publicProfile: { __typename?: 'PublicProfile', id: string, name: string, title?: string | null | undefined, bio?: string | null | undefined, imageUrl?: string | null | undefined, socialMediaUrls?: { __typename?: 'SocialMediaUrls', facebookUrl?: string | null | undefined, instagramUrl?: string | null | undefined, linkedinUrl?: string | null | undefined, xUrl?: string | null | undefined } | null | undefined } }> } | null | undefined };


export const SpeakersDocument = gql`
    query Speakers($mediaHashedId: HashedId!) {
  anonymousMedia(hashedId: $mediaHashedId) {
    id
    transcriptSpeakers {
      id
      role
      rowOrder
      publicProfile {
        id
        name
        title
        bio
        imageUrl
        socialMediaUrls {
          facebookUrl
          instagramUrl
          linkedinUrl
          xUrl
        }
      }
    }
  }
}
    `;

/**
 * __useSpeakersQuery__
 *
 * To run a query within a React component, call `useSpeakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpeakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpeakersQuery({
 *   variables: {
 *      mediaHashedId: // value for 'mediaHashedId'
 *   },
 * });
 */
export function useSpeakersQuery(baseOptions: Apollo.QueryHookOptions<SpeakersQuery, SpeakersQueryVariables> & ({ variables: SpeakersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpeakersQuery, SpeakersQueryVariables>(SpeakersDocument, options);
      }
export function useSpeakersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpeakersQuery, SpeakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpeakersQuery, SpeakersQueryVariables>(SpeakersDocument, options);
        }
export function useSpeakersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SpeakersQuery, SpeakersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SpeakersQuery, SpeakersQueryVariables>(SpeakersDocument, options);
        }
export type SpeakersQueryHookResult = ReturnType<typeof useSpeakersQuery>;
export type SpeakersLazyQueryHookResult = ReturnType<typeof useSpeakersLazyQuery>;
export type SpeakersSuspenseQueryHookResult = ReturnType<typeof useSpeakersSuspenseQuery>;
export type SpeakersQueryResult = Apollo.QueryResult<SpeakersQuery, SpeakersQueryVariables>;